const JobStatus = {

  NOT_STARTED: {},

  IN_PROGRESS: {},

  PAUSED: {},
  
  COMPLETED: {}

}

export default JobStatus



// WEBPACK FOOTER //
// ./src/infra/JobStatus.js